import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { trackEvent } from '../../libs';

class Item extends React.Component {
  componentWillMount() {
    this.setState({
      active: false
    });

    this.setActive(this.props.brochures);
  }

  componentWillReceiveProps(props) {
    this.setActive(props.brochures);
  }

  setActive = (brochures) => {
    if (brochures) {
      this.setState({
        active: brochures.some(i => i.name === this.props.name)
      });
    }
  };

  previewHandle = (isPriceList) => {
    const { name, preview } = this.props;

    trackEvent({
      eventCategory: 'Brochure',
      eventAction: 'Preview Button',
      eventLabel: name,
    });

    if (isPriceList) {
      window.open(preview);
      return false;
    }
  };

  emailHandle = () => {
    const { name, value, onClick } = this.props;

    onClick(name, value);
  };

  render() {
    const { title, preview, type, carUrlPart } = this.props;

    let path = `/car-${carUrlPart}`;

    if (type === 'accessories' || type === 'custom') {
      path += `/${type}`;
    }

    return (
      <div className="car-item__service">
        <div className="car-item__service__title">{title}</div>
        <div className="car-item__service__container">
          {preview.includes('serviceportal') ? <a
            className="car-item__see"
            data-id={title}
            onClick={() => this.previewHandle(true)}
            href="javascript:void(0);"
          /> : <Link
            to={path}
            onClick={() => this.previewHandle()}
            target="_blank"
          />}

          <i
            data-id={title}
            className={classNames({
              'car-item__email': true,
              'isActive': this.state.active
            })}
            onClick={() => this.emailHandle()}
          />
        </div>
      </div>
    );
  }
}


Item.propTypes = {
  dispatch: PropTypes.func,
  onClick: PropTypes.func,
  name: PropTypes.string,
  carUrlPart: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  preview: PropTypes.string,
  brochures: PropTypes.array,
};

export default connect(store => ({
  brochures: store.mainReducer.brochures,
}))(Item);



// WEBPACK FOOTER //
// ./src/components/Brochures/Item.js